import React, { useEffect, useState, useMemo } from "react";
import { Chart } from "primereact/chart";
import { t } from "i18next";
import EventEmitter, { Events } from "../../services/eventemitter";

interface ChatResponseTimeProps {
  loading:boolean
  data: {
    hourly: string;
    actualChatResponse: string | null;
    dealerManaged: string | null;
    coManaged: string | null;
  }[];
}

const ChatResponseTime = React.memo((props: ChatResponseTimeProps) => {
  const [hours, setHours] = useState<string[]>([]);
  const [actualChatResponseTime, setActualChatResponseTime] = useState<number[]>([]);
  const [dealerManaged, setDealerManaged] = useState<number[]>([]);
  const [coManaged, setCoManaged] = useState<number[]>([]);
  const [isEmpty, setIsEmpty] = useState(false);
  const [loading, setloading] = useState(true);
  const [refreshState, setRefreshState] = useState<any>(new Date())

  useEffect(() => {
      EventEmitter.on(Events.forceFullyChangeLanguage, forceFullyChangeLanguage);
  }, [])
  
  const forceFullyChangeLanguage = () => {
      setRefreshState(new Date()?.getTime())
  }

  useEffect(() => {
    let hoursArray: string[] = [];
    let actualChatResponseArray: number[] = [];
    let dealerManagedArray: number[] = [];
    let coManagedArray: number[] = [];

    props.data?.forEach((element) => {
      hoursArray.push(element.hourly);

      if (element.actualChatResponse === null) {
        actualChatResponseArray.push(0);
      } else {
        actualChatResponseArray.push(parseInt(element.actualChatResponse));
      }

      if (element.dealerManaged === null) {
        dealerManagedArray.push(0);
      } else {
        dealerManagedArray.push(parseInt(element.dealerManaged));
      }

      if (element.coManaged === null) {
        coManagedArray.push(0);
      } else {
        coManagedArray.push(parseInt(element.coManaged));
      }
    });

    setHours(hoursArray);
    setActualChatResponseTime(actualChatResponseArray);
    setDealerManaged(dealerManagedArray);
    setCoManaged(coManagedArray);
    setloading(false);
  }, [props.data]);

  const multiAxisData = useMemo(() => ({
    labels: hours,
    datasets: [
      {
        label:t('ReportComponent.ActualResponseTime'),
        backgroundColor: "#999999",
        data: actualChatResponseTime,
      },
      {
        label:t('ReportComponent.Dealer Managed'),
        backgroundColor: "#42A5F5",
        data: dealerManaged,
      },
      {
        label:t('ReportComponent.Co Managed'),
        backgroundColor: "#4B4848",
        data: coManaged,
      },
    ],
  }), [hours, actualChatResponseTime, dealerManaged, coManaged]);

  const getLightTheme = () => {
    let multiAxisOptions = {
      responsive: true,
      tooltips: {
        mode: "index",
        intersect: true,
      },
      legend: {
        labels: {
          fontColor: "#495057",
        },
      },
    };

    return {
      multiAxisOptions,
    };
  };

  const { multiAxisOptions } = getLightTheme();

  return (
    <>
      {!loading && (
        <div className="card">
          <h6>{t('ReportComponent.Chat Response Time')}</h6>
          <Chart type="bar" data={multiAxisData} options={multiAxisOptions} />
        </div>
      )}
    </>
  );
});

export default ChatResponseTime;
